import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
// import { HOURLY_TIME_PERIOD } from '../../config/constants/analytics';
import BusyModeBarChart from './BarChart/BusyModeBarChart';
import BusyModeHeatmapChart from './Heatmap/BusyModeHeatmapChart';
import BusyModeReasonPieChart from './PieChart/BusyModeReasonPieChart';
import BusyModeLogTable from './Tables/BusyModeLogTable';
import SectionCard from './components/SectionCard';
import { makeSelectProperty } from './selectors';

const BusyModeCard = ({
  isTimePeriodFilterStatusChanged,
  selectedComparisonType,
}) => {
  // const isHourly = selectedTimePeriod.slug === HOURLY_TIME_PERIOD; // No heatmap
  const isHourly = false;

  let busyModeChartEl;
  if (!isTimePeriodFilterStatusChanged) {
    busyModeChartEl = isHourly ? (
      <BusyModeHeatmapChart />
    ) : (
      <BusyModeBarChart />
    );
  }

  return (
    <div className="flex flex-col gap-y-4">
      <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
        <SectionCard
          title="Pause Store"
          metricKey="busyMode"
          className="h-full"
        >
          <div className="w-full" style={{ minHeight: 280 }}>
            {busyModeChartEl}
          </div>
        </SectionCard>
        <SectionCard
          title="Pause Store Reasons"
          metricKey="busyMode"
          className="h-full"
        >
          <BusyModeReasonPieChart key={selectedComparisonType} />
        </SectionCard>
      </div>
      <BusyModeLogTable />
    </div>
  );
};

BusyModeCard.propTypes = {
  isTimePeriodFilterStatusChanged: PropTypes.bool,
  selectedComparisonType: PropTypes.string,
};

const mapStateToProps = createStructuredSelector({
  selectedComparisonType: makeSelectProperty('selectedComparisonType'),
  isTimePeriodFilterStatusChanged: makeSelectProperty(
    'isTimePeriodFilterStatusChanged',
  ),
});

const withConnect = connect(mapStateToProps);

export default compose(withConnect)(BusyModeCard);
